__turbopack_context__.v({
  "card": "styles-module-scss-module__le5N7q__card",
  "content": "styles-module-scss-module__le5N7q__content",
  "description": "styles-module-scss-module__le5N7q__description",
  "image": "styles-module-scss-module__le5N7q__image",
  "imageWrapper": "styles-module-scss-module__le5N7q__imageWrapper",
  "name": "styles-module-scss-module__le5N7q__name",
  "playIcon": "styles-module-scss-module__le5N7q__playIcon",
  "root": "styles-module-scss-module__le5N7q__root",
  "title": "styles-module-scss-module__le5N7q__title",
});
